<template>
  <div style="position: relative; overflow: hidden">
    <figure
      class="card card-product overflow-hidden"
      :style="disabled && 'box-shadow: none'"
    >
      <div v-if="disabled" class="product-disabled-overlay">
        <div class="mx-auto">
          <font-awesome-icon
            icon="fa-solid fa-ban"
            size="6x"
            :style="{ color: 'rgb(175, 0, 0)', marginBottom: '15px' }"
          />
          <p style="text-align: center; margin: auto">Not available</p>
        </div>
      </div>
      <router-link :to="{ name: 'product', params: { id: product.id } }">
        <div class="img-wrap">
          <img :src="product.images[0].src" />
          <!-- <a class="btn-overlay" href="#"
            ><i class="fa fa-search-plus"></i> voorbeeld</a
          > -->
        </div>
        <figcaption class="info-wrap">
          <h4 class="title mb-4">{{ product.name }}</h4>
          <div class="action-wrap flex gap-3 items-center">
            <!-- <button class="btn btn-primary btn-sm" @click="addToCart(product)">
            BESTELLEN
          </button> -->
            <div class="price-wrap">
              <div class="price-new" v-html="product.price_html"></div>
            </div>
          </div>
        </figcaption>
      </router-link>
    </figure>
  </div>
</template>

<script>
import "@/assets/fonts.scss";
import AddingPopupWindow from "@/components/AddingPopupWindow";
import { mapActions } from "vuex";
export default {
  name: "ProductCard",
  components: {
    AddingPopupWindow,
  },
  props: {
    product: Object,
  },
  methods: {
    ...mapActions("cart", ["addToCart"]),
  },
  computed: {
    disabled() {
      return this.product.stock_status === "outofstock";
    },
  },
};
</script>

<style>
.price-new ins span,
.price-new > span > bdi {
  font-size: 1.7rem;
  font-weight: bold;
  color: var(--theme);
}

.product-disabled-overlay {
  z-index: 10;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  text-align: center;
  padding: 3rem;
  background-color: rgba(255, 255, 255, 0.7);
  top: 0;
  left: 0;
}

.product-disabled-overlay p {
  color: rgb(175, 0, 0);
}

.price-new del {
  font-size: 1.35rem;
}

.price-wrap {
  display: flex;
  align-items: center;
}
</style>
